class HandleData {
  static async fetchURL(url, handleError) {
    const response = await fetch(url);
    if (response.ok) {
      return await response.json();
    } else if (typeof handleError === 'function') {
      handleError(response);
    }
  }

  static async get(url, handleSuccess, handleError) {
    const data = await HandleData.fetchURL(url, handleError);

    if (typeof handleSuccess === 'function') {
      return handleSuccess(data);
    } else {
      console.error('handleSuccess is not a function');
    }
  }
}

export default HandleData;
